const handleLogout = () => {
  window.location.href = '/logout';
};
export default handleLogout;
